module.exports = __webpack_public_path__ + "static/media/SwaggerUI.e93b1b76.png";